<h2 mat-dialog-title>Novo quadro</h2>

<div mat-dialog-content class="dialog-tarefa-quadro__conteudo">
  <label class="dialog-tarefa-quadro__campo">Nome do quadro
    <input [(ngModel)]="noQuadro" maxlength="100" placeholder="Informe o nome do quadro" (keyup.enter)="salvar()">
  </label>
  <label class="dialog-tarefa-quadro__campo dialog-tarefa-quadro__campo--cor">Cor de fundo do quadro
    <button type="button" class="dialog-tarefa-quadro__seletor-cor" [matMenuTriggerFor]="menuCorQuadro"
      [attr.aria-label]="'Selecionar a cor de fundo do quadro ' + noCor"><span [style.background]="noCor"></span></button>
    <span>{{ noCor }}</span>
  </label>
  <mat-menu #menuCorQuadro="matMenu"><ng-template matMenuContent><color-picker (click)="$event.stopPropagation()"
        [(value)]="noCor" [(format)]="formatoCor" [hideAlpha]="true"></color-picker></ng-template></mat-menu>
  <div class="dialog-tarefa-quadro__cabecalho-listas"><strong>Listas</strong><button mat-stroked-button type="button"
      (click)="adicionarColuna()"><mat-icon>add</mat-icon>Adicionar lista</button></div>
  <div cdkDropList [cdkDropListData]="colunas" (cdkDropListDropped)="reordenarColunas($event)">
    <section class="dialog-tarefa-quadro__lista" *ngFor="let coluna of colunas; let indice = index" cdkDrag [cdkDragStartDelay]="atrasoArraste">
      <label cdkDragHandle>Nome da lista<input [(ngModel)]="coluna.noColuna" maxlength="60"
          placeholder="Informe o nome da lista" (mousedown)="$event.stopPropagation()"></label>
      <label>Cor<button type="button" class="dialog-tarefa-quadro__seletor-cor" [matMenuTriggerFor]="menuCorLista"
          [attr.aria-label]="'Selecionar a cor da lista ' + (indice + 1)"><span [style.background]="coluna.noCor"></span></button></label>
      <span>{{ coluna.noCor }}</span>
      <button mat-icon-button type="button" aria-label="Remover lista" [disabled]="colunas.length === 1"
        (click)="removerColuna(indice)"><mat-icon>delete</mat-icon></button>
      <mat-menu #menuCorLista="matMenu"><ng-template matMenuContent><color-picker (click)="$event.stopPropagation()"
            [(value)]="coluna.noCor" [(format)]="formatoCor" [hideAlpha]="true"></color-picker></ng-template></mat-menu>
    </section>
  </div>
</div>

<div mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancelar()">Cancelar</button>
  <button mat-raised-button color="primary" type="button" [disabled]="!podeSalvar" (click)="salvar()">Criar
    quadro</button>
</div>
